import React from 'react';

const SportsExchangeIcon = ({ size = '28px', className = '' }) => {
  return (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 32 32"
      width={size}
      height={size}
      className={className}
    >
      {/* Exchange/Handshake icon for Sports Exchange */}
      <circle 
        cx="16" 
        cy="16" 
        r="13" 
        fill="var(--color-primary)"
        stroke="white"
        strokeWidth="1"
        opacity="0.2"
      />
      {/* Left hand */}
      <path 
        fill="var(--color-primary)"
        d="M10 18L8 20L10 22L12 20L10 18Z"
      />
      <path 
        fill="var(--color-primary)"
        d="M8 16L6 18L8 20L10 18L8 16Z"
      />
      {/* Right hand */}
      <path 
        fill="var(--color-primary)"
        d="M22 18L20 20L22 22L24 20L22 18Z"
      />
      <path 
        fill="var(--color-primary)"
        d="M24 16L22 18L24 20L26 18L24 16Z"
      />
      {/* Connection/Exchange lines */}
      <path 
        fill="none"
        stroke="var(--color-primary)"
        strokeWidth="2"
        strokeLinecap="round"
        d="M14 16L18 16"
      />
      <path 
        fill="var(--color-primary)"
        d="M16 14L18 16L16 18L14 16L16 14Z"
      />
    </svg>
  );
};

export default SportsExchangeIcon;
